import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  "fill-rule": "evenodd",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "2",
  "clip-rule": "evenodd",
  viewBox: "0 0 42 43"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ff0038",
      "fill-rule": "nonzero",
      d: "M.166 42.532h9.88L.166 26.928v15.604Zm0-30.575v10.238l12.746 20.109 10.081-15.803-9.132-14.544H.166Zm32.083 0-8.1 12.738v17.836h17.344V11.957h-9.244Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "nonzero",
      d: "M4.057 10.77C1.692 10.77 0 8.939 0 6.665c0-2.273 1.693-4.132 4.057-4.132 1.891 0 3.325 1.058 3.782 2.836h-2.15a1.891 1.891 0 0 0-1.632-.99c-1.115 0-2.014 1.039-2.014 2.304 0 1.235.899 2.258 2.014 2.258a1.853 1.853 0 0 0 1.646-1.007h2.152c-.459 1.783-1.893 2.836-3.798 2.836Zm4.307-8.039h2.018v7.857H8.364zm7.232 7.842c-2.294.243-3.528-1.145-3.528-3.295V4.516h-.94V2.731h.94V0h2.012v2.731h1.411v1.785H14.08v2.776c0 1.099.503 1.51 1.512 1.45l.004 1.831Zm.815-7.842h2.007v7.857h-2.007zm9.556 7.856h-6.863V8.848l4.148-4.292h-3.981V2.731h6.555v1.8l-4.073 4.234h4.214v1.822Zm2.044-3.142a1.997 1.997 0 0 0 1.967 1.556 1.831 1.831 0 0 0 1.67-.917h2.15c-.457 1.601-1.845 2.684-3.797 2.684a4.066 4.066 0 0 1-4.034-4.095c0-2.272 1.815-4.133 4.027-4.133 2.317 0 4.233 1.799 3.951 4.912l-5.934-.007Zm3.935-1.654a1.97 1.97 0 0 0-1.968-1.496c-.916 0-1.648.58-1.941 1.496h3.909Zm9.651 4.796h-2.011V6.001c0-.457-.138-1.556-1.464-1.556a1.495 1.495 0 0 0-1.105.442 1.484 1.484 0 0 0-.43 1.109v4.586H34.58V2.731h1.921v.767a2.594 2.594 0 0 1 2.026-.965c1.845 0 3.066 1.389 3.066 3.463l.004 4.591Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "logo"}) } }